export default __webpack_public_path__ + "static/media/kitchen.648d61db.mp3";